import { Button, Group, Stack, Text, TextInput, Title } from '@mantine/core'
import ModalHeader from '../../shared/ModalHeader/ModalHeader'
import { Controller } from 'react-hook-form'
import { useViewModel } from './Anonymous.vm'
import {
    AtSign,
} from 'lucide-react'
import { Form } from '@/components/atoms/Form'

export const AnonymousAuthTitle = () => {
    const metadata = {
        title: 'Commande express',
        description:
            "Continuer votre commande en tant qu'invité.",
    }
    return <ModalHeader {...metadata} />
}

export const AnonymousAuth = () => {
    const viewModel = useViewModel()
    return <AnonymousView {...viewModel} />
}

const AnonymousView = ({
    form,
    onSubmit,
    send,
}: ReturnType<typeof useViewModel>) => {
    return (
        <Stack className="p-4">
            <Title order={6}>Avant de continuer</Title>
            <Text size="xs" c="gray.6">
                Vous pouvez continuer votre commande en tant qu'invité, nous
                avons besoin de votre adresse e-mail pour vous envoyer votre
                confirmation de commande.
            </Text>

            <Form onSubmit={onSubmit}>
                <Stack>
                    <Controller
                        control={form.control}
                        name="email"
                        render={({ field }) => (
                            <TextInput
                                {...field}
                                error={form.formState.errors.email?.message}
                                label="E-mail"
                                type="email"
                                icon={<AtSign className="w-4 h-4 " />}
                                placeholder="ex. mon-email@email.fr "
                            />
                        )}
                    />
                    <Group ml="auto">
                        <Button type="submit">Continuer</Button>
                    </Group>
                </Stack>
            </Form>
        </Stack>
    )
}
